import { AppAvatar, AppBox, AppIconButton, AppTitle } from "../../../../../commons/components";
import { FootballTournamentManager } from "../../../../../commons/models/football/football-tournament-manager";
import IconPersonDelete from "../../../../../commons/components/icons/person-delete";

interface TournamentManagerCardProps {
  manager: FootballTournamentManager;
  withRemove?: boolean;
  onRemove?: (team: FootballTournamentManager) => void;
}

export default function TournamentManagerCard({ manager, onRemove, withRemove = true }: TournamentManagerCardProps) {
  return (
    <AppBox justifyContent="space-between" alignItems="center" p={"xs"} gap="sm">
      <AppBox gap="xs" alignItems="center">
        <AppAvatar username={manager.fullName} src={manager.avatar || ""} size="md" />
        <AppTitle as="h6">{manager.fullName}</AppTitle>
      </AppBox>
      {withRemove && (
        <AppIconButton
          variant="light"
          color="danger"
          onClick={() => {
            if (onRemove) {
              onRemove(manager);
            }
          }}
          icon={<IconPersonDelete />}
        />
      )}
    </AppBox>
  );
}
